import { CMCD_COMMON_KEYS } from './CMCD_COMMON_KEYS.js';
import { CMCD_REQUEST_KEYS } from './CMCD_REQUEST_KEYS.js';
import { isCmcdCustomKey } from './isCmcdCustomKey.js';
/**
 * Check if a key is a valid CMCD request key.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a valid CMCD request key, `false` otherwise.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/isCmcdRequestKey.test.ts#example}
 */
export function isCmcdRequestKey(key) {
    return CMCD_COMMON_KEYS.includes(key) ||
        CMCD_REQUEST_KEYS.includes(key) ||
        isCmcdCustomKey(key);
}
//# sourceMappingURL=isCmcdRequestKey.js.map